// extracted by mini-css-extract-plugin
export default {"MainBtn":"MainBtn_MainBtn__lj9Vp","animationMainBtn":"MainBtn_animationMainBtn__xXSFJ"};